import { Button, Icon } from '@dixa/lib-shared-habla';
import { shallowEqual } from 'react-redux';

import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canConversationTransferToQueue } from 'components/conversation/utils/conversationTransfer';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { TransferToQueueDropdown } from './components/transferToQueueDropdown/transferToQueueDropdown';
import styles from './conversationTransferToQueue.module.scss';

export const ConversationTransferToQueue = (): JSX.Element => {
  const [
    metaConversation,
    conversationAsyncStatus,
    latestMessengerConversation,
  ] = useAppSelector(
    (state) => [
      state.conversation.metaConversation,
      state.conversation.asyncStatus.getConversation,
      getLatestFacebookConversation(state),
    ],
    shallowEqual,
  );

  const canTransferToQueue = canConversationTransferToQueue(
    metaConversation,
    latestMessengerConversation,
  );

  return canTransferToQueue ? (
    <TransferToQueueDropdown />
  ) : (
    <Button
      variant="tertiary"
      disabled
      isLoading={conversationAsyncStatus === 'loading'}
      slotStart={<Icon name="flow" />}
      className={styles.button}
    >
      {metaConversation.conversation.queue?.name || `Not in queue`}
    </Button>
  );
};
